__turbopack_context__.v({
  "SFilledPath": "Jqukua_SFilledPath",
  "SStarSvg": "Jqukua_SStarSvg",
  "isFilled": "Jqukua_isFilled",
});
